// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { ICCIEx } from './iCCIEx';
export const iCCI = 'iCCI';
export class ICCI extends ICCIEx {
    constructor(maPeriod, maType) {
        super(maPeriod, maType, PriceType.Typical);
    }
    get Name() {
        return iCCI;
    }
}
